import { createStore, applyMiddleware } from "redux";
import Thunk from "redux-thunk";
import rootReducer from "./reducers/rootReducer";

export const middlewares = [Thunk];

export const createStoreWithMiddlware = applyMiddleware(...middlewares)(
  createStore
);

export const store = createStoreWithMiddlware(rootReducer);
